<app-loader *ngIf="isLoading"></app-loader>

<div class="text-center">

    <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimitervalue" [centralLabel]="centralLabel"
        [options]="options"></rg-gauge-chart>
    <div *ngIf="showUrl" class="d-flex justify-content-center align-items-center my-1">
        <div class="fw-bold fs-xl">
            <span [style.color]="statusClr"> {{ privacyScore }} </span>
            <span class="gray-clr fs-14">/ {{ privacyTotalScore }} </span>
        </div>
        <div class="ms-2">
            <span class="badge badge-pill status-text" [style.color]="statusClr"
                [style.background-color]="statusBg">{{privacyScoreStatus}}</span>
        </div>
    </div>
    <div *ngIf="showUrl" class="w-100 d-flex justify-content-center shiftingTextRight">
        <div class="text-sm ">
            <!-- <h5 class="recommend fw-bold">{{"DASHBOARD.RECOMMENDATIONS" | translate}} <span *ngIf="privacyScore <= 800"
                    class="fw-normal">({{privacyRecommendations?.length}})</span></h5> -->
            <h5 class="recommend fw-bold">{{"DASHBOARD.RECOMMENDATIONS" | translate}} <span
                    class="fw-normal">({{privacyRecommendations?.length}})</span></h5>
            <div *ngIf="privacyRecommendations?.length != null">
                <div class=" my-2 mw-250" [ngClass]="i >= 0 && i <= 3 ? 'd-flex flex-wrap' : 'd-none' "
                    *ngFor="let item of privacyRecommendations;let i = index">
                    <div *ngIf='i < 3' class="item-recommend " data-toggle="tooltip" data-placement="top"
                        title="{{ item.title }}">
                        {{item.title }}
                </div>
                </div>
            </div>
            <div *ngIf="privacyScore == 1000">
                <div class="d-flex">
                    {{"DASHBOARD.PERFECT1000" | translate}}
                </div>
                <div class="d-flex">
                    {{"DASHBOARD.NOACTIONPENDING" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>